export default {
  name: 'error-block',
  props: {
    'is-error': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classObject() {
      return {
        input__error: this.isError
      }
    }
  }
}
